import React, { useState, useEffect, useRef, forwardRef } from "react";
import Footer from "../../../../components/home_page/Footer";
import { useDispatch } from "react-redux";
import { closeModal } from "../../../../redux/actions/action-creator";
import InputField from "../../../../components/Input/InputField";
const DispatchDetails = forwardRef((props, ref_name) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        dispatch(closeModal("dispatch_detail_modal"));
        ref_name?.current?.focus();
        e.stopPropagation();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [dispatch]);

  return (
    <div className="my-card">
      <div
        className="cross_button"
        onClick={() => {
          return (
            dispatch(closeModal("dispatch_detail_modal")),
            ref_name?.current?.focus()
          );
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-x"
          viewBox="0 0 16 16"
        >
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
        </svg>
      </div>
      <div
        className="container pb-3 border border-dark"
        id="card-period"
        style={{ width: "60%", background: "#fff" }}
      >
        <div className="row">
          <div className="col border-bottom">
            <b>Dispatch Details</b>
          </div>
        </div>
        <div className="row">
          <div className="col">
            {props.inputFields
              .slice(17, 24)
              .map(({ label, name, type, isRequired }, index) => (
                <InputField
                  height="3vh"
                  key={index}
                  lable={label}
                  type={type}
                  name={name}
                  value={props.data[name] || ""}
                  handleChange={props.handleChange}
                  handleBlur={props.handleBlur}
                  handleFocus={props.handleFocus}
                  isRequired={isRequired}
                  ref={props.inputRefs[name]}
                />
              ))}
          </div>
        </div>
      </div>
      <div className="tomasterfooter" style={{ background: "red" }}>
        <Footer />
      </div>
    </div>
  );
});

export default DispatchDetails;
